import PCLNAnalytics from '@pcln/analytics'
import axios from 'axios'
import { URL, QUERY } from '../nearbyAirport/constants'
import { formatResponse } from './helpers'

const nearbyAirportApiRequest = (value) =>
  axios
    .post(URL, {
      query: QUERY,
      operationName: "nearbyAirports",
      variables: {
        value: {
          numAirports: 10,
          productId: "1",
          queryText: value
        }
      }
    })
    .then(({ data }) => formatResponse(data?.data?.nearbyAirports?.matchedRegions || []))
    .catch((err) => {
      PCLNAnalytics.logError({
        message: err.message,
        severity: 3,
        stack: 'pages/Landing typeaheadApiRequest',
      })
    })

export { nearbyAirportApiRequest }
